import { Actors as A, createAuthorizeAdvertiserIdTransform, Tenants as T } from '@mntn/auth-types'
import { QueryIDSchema } from '@mntn/zod'
import { z } from 'zod'

export const AudiencePreviewSchema = z.object({
  id: z.number(),
  name: z.string(),
  availableAudienceSize: z.number(),
})

export const CompareAudienceRequestSchema = z.object({
  'advertiser-id': QueryIDSchema,
  'audience-id': QueryIDSchema,
  'campaign-group-id': QueryIDSchema,
})

export const CompareAudienceContextSchema = z
  .object({
    query: CompareAudienceRequestSchema,
    principal: T.KindSchema('advertiser').and(A.UserSchema),
  })
  .transform(
    createAuthorizeAdvertiserIdTransform(
      request => request.query['advertiser-id'],
      (request, advertiserId) => ({
        ...request,
        query: { ...request.query, 'advertiser-id': advertiserId },
      }),
    ),
  )

export const CompareAudienceResponseSchema = z.object({
  data: z.object({
    original: AudiencePreviewSchema,
    current: AudiencePreviewSchema,
  }),
})

export type AudiencePreview = z.infer<typeof AudiencePreviewSchema>
export type CompareAudienceRequest = z.infer<typeof CompareAudienceRequestSchema>
export type CompareAudienceResponse = z.infer<typeof CompareAudienceResponseSchema>
